import './sitewide-banner.scss';

document.addEventListener("DOMContentLoaded", function() {
    var banner = document.getElementById('sitewide-banner');
    var closeButton = document.getElementById('close-banner');
    var fixedHeader = document.querySelector('.site-header');
    var stickyOffsetHeader = document.querySelector('.sticky-offset-header');
    var adminBar = document.getElementById('wpadminbar');

    // Function to adjust sticky header position
    function adjustStickyHeaderPosition() {
        if (stickyOffsetHeader && fixedHeader && banner) {
            // Ensure the sticky header has the correct positioning
            stickyOffsetHeader.style.position = 'sticky';
            
            if (getCookie('STYXKEY_hideBanner')) {
            } else {
                // Recalculate header height (in case it changes on scroll)
                let totalOffset = fixedHeader.offsetHeight;

                // Add admin bar height if it exists
                if (adminBar) {
                    totalOffset += adminBar.offsetHeight;
                }

                stickyOffsetHeader.style.setProperty('top', `${totalOffset}px`, 'important');
            }

        }
    }

    // Check if the banner and close button exist in the DOM
    if (banner && closeButton) {
        // Initial positioning
        adjustStickyHeaderPosition();

        // Add scroll event listener to readjust
        window.addEventListener('scroll', function() {
            adjustStickyHeaderPosition();
        });

        // Check if the cookie exists before displaying the banner
        if (getCookie('STYXKEY_hideBanner')) {
            banner.style.display = 'none'; // Hide the banner if cookie is set
        } else {
            banner.style.display = 'block'; // Show the banner if no cookie is set
        }

        // Add click event to the close button
        closeButton.addEventListener('click', function() {
            banner.style.display = 'none'; // Hide the banner
            if (stickyOffsetHeader) {
                stickyOffsetHeader.style.removeProperty('top'); // Remove the inline top style
            }
            setCookie('STYXKEY_hideBanner', 'true', 7); // Set a cookie to hide the banner for 7 days


            closeButton.focus();
        });
    }

    // Function to set a cookie
    function setCookie(name, value, days) {
        var expires = "";
        if (days) {
            var date = new Date();
            date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
            expires = "; expires=" + date.toUTCString();
        }
        document.cookie = name + "=" + (value || "") + expires + "; path=/";
    }

    // Function to get a cookie
    function getCookie(name) {
        var nameEQ = name + "=";
        var ca = document.cookie.split(';');
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ') c = c.substring(1, c.length);
            if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
        }
        return null;
    }
});